import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footer bg-light mt-4">
        <div className="container pb-3 pt-4">
            <h6 className="d-flex justify-content-center">Copyright @2023</h6>
            <h6 className="d-flex justify-content-center">Project using 'React & Firebase'</h6>
        </div>
      </div>
    </>
  );
};

export default Footer;
